import React from 'react';
import { Switch } from 'antd';

const Checkbox = ({ checked, onChange, size = '2rem', label, preLabel, disabled = false }) => {
  return (
    <div
      className={`flex items-center ${
        disabled ? 'opacity-50 cursor-not-allowed user-select-none' : ''
      }`}
    >
      {preLabel && <label className="text-xs text-gray-600 mr-2 select-none">{preLabel}</label>}
      <Switch
        checked={checked}
        onChange={onChange}
        size={size === '2rem' ? 'default' : 'small'}
        style={{
          backgroundColor: checked ? '#3F51B5' : undefined,
        }}
        disabled={disabled}
      />
      {label && <label className="text-sm text-gray-600 ml-2 select-none">{label}</label>}
    </div>
  );
};

export default Checkbox;
